import { STAY_POSTED_EMAIL_INPUT_ID } from '~/features/ai-marketer/constants';

// Browsers without `scrollend` (older Safari) fall back to focusing after the smooth scroll should be done.
const SCROLL_FALLBACK_MS = 1000;

export function focusStayPostedEmailAfterScroll() {
  let hasFocused = false;

  const focusEmail = () => {
    if (hasFocused) return;
    hasFocused = true;
    window.removeEventListener('scrollend', focusEmail);
    document.getElementById(STAY_POSTED_EMAIL_INPUT_ID)?.focus({ preventScroll: true });
  };

  window.addEventListener('scrollend', focusEmail, { once: true });
  window.setTimeout(focusEmail, SCROLL_FALLBACK_MS);
}
